import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiConnectorService } from 'src/app/___LOGIC/__api/api-connector.service';
import { AssetsService } from 'src/app/___LOGIC/__common/_assets/assets.service';
import { DependencyService } from 'src/app/___LOGIC/__common/dependency.service';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';
import { NavigationService } from 'src/app/___LOGIC/__nav/navigation.service';

@Component({
  selector: 'app-client-manager',
  templateUrl: './client-manager.component.html',
  styleUrls: ['./client-manager.component.css']
})
export class ClientManagerComponent implements OnInit {

  clients = [];

  constructor(private resolver: ResolverService,private router: Router,private commonFunctions: FunctionsService,private guiFlow: GuiFlowService,private navigationService: NavigationService,private dependencyService: DependencyService,private assetsService: AssetsService) {}

  ngOnInit(): void {
    this.fetch();
  }

  fetch(){
    this.dependencyService.getTableData('clientDetails').subscribe(
      (res) => {this.clients = res.items}
    )
  }

  editProfile(row){
    this.resolver.setCurrentClientCard(row);
    this.commonFunctions.setSelectedClientId(row.id);
    this.resolver.getClientDetails(true);
    this.router.navigateByUrl('profile/edit/'+row.id);
  }

  goToProfile(event){
    this.resolver.setCurrentClientCard(event.selected);
    this.commonFunctions.setSelectedClientId(event.selected.id);
    this.resolver.getClientDetails(true);
    this.router.navigateByUrl('profile/edit/'+event.selected.id);
  }

  reload(){
    this.fetch();
  }

  isLoading(){
    return this.resolver.isLoading('getClientList');
  }

  copyToClipbooard(row){
    this.commonFunctions.copyToClipboard(row.email);
    this.guiFlow.openSimpleSnackBar('Copied to clipboard 💾', 'info' );
  }

  getImageUrl(url){
    return this.assetsService.getImageUrl(url);
  }

  goBack(){
    this.navigationService.goBack();
  }

  goToPage(page){
    this.router.navigateByUrl(page);
  }

}